import { computed, ref } from "vue";

const arrayCoverCardThemes = ['full', 'no-card', 'empty'];

export const cardTheme = ref(localStorage.getItem('card') || 'default')

export const VALID_THEMES_CARD = {
    '': 'default',
    'default': 'default',
    'rect': 'rect',
    'full': 'full',
    'empty': 'empty',
    'no-card': 'no-card'
}

export function applyCardTheme(newCardTheme: string) {
    if (!Object.values(VALID_THEMES_CARD).includes(newCardTheme)) {
        newCardTheme = 'default'
    }

    cardTheme.value = newCardTheme

    localStorage.setItem('card', newCardTheme)
}

export const imageCoverCardTheme = computed(() => {
    return arrayCoverCardThemes.includes(cardTheme.value)
})